import { render, staticRenderFns } from "./ChartMarketRight.vue?vue&type=template&id=fc454ac4&scoped=true"
import script from "./ChartMarketRight.vue?vue&type=script&lang=js"
export * from "./ChartMarketRight.vue?vue&type=script&lang=js"
import style0 from "./ChartMarketRight.vue?vue&type=style&index=0&id=fc454ac4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc454ac4",
  null
  
)

export default component.exports